function generateIdFromName(name) {
    return name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
}


const productosTejidosExclusivos = [

    {
        nombre: 'Tela Australis',
        colores: ['Beige', 'Aguamarina', 'Coffe'],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/tejidosExclusivos/australis/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/australis/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/australis/2.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/australis/3.jpg")
        ]
    },{
        nombre: 'Tela BasicLine',
        colores: ['Ivory', 'Chocolate', 'Ceniza', 'White'],
        categoria: 'Telas Exclusivas',
        ancho: '2.50',
        images: [
            require("../../assets/img/productos/tejidosExclusivos/basicLine/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/basicLine/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/basicLine/2.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/basicLine/3.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/basicLine/4.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/basicLine/5.jpg")
        ]
    },{
        nombre: 'Tela Brick',
        colores: ['Ivory', 'Gris'],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/tejidosExclusivos/brick/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/brick/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/brick/2.jpg"),
        ]
    },{
        nombre: 'Tela Forest',
        colores: ['Ivory', 'Canela', 'Gris'],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/tejidosExclusivos/forest/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/forest/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/forest/2.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/forest/3.jpg")
        ]
    },{
        nombre: 'Tela Gradiente',
        colores: ['White', 'Gris','Ivory' ],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/tejidosExclusivos/gradiente/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/gradiente/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/gradiente/2.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/gradiente/3.jpg")
        ]
    },{
        nombre: 'Tela Lava',
        colores: ['White', 'Sand','Dark Grey'],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/tejidosExclusivos/lava/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/lava/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/lava/2.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/lava/3.jpg")
        ]
    },{
        nombre: 'Tela Montana',
        colores: ['Brown', 'Mushroom','LigthGrey' ],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/tejidosExclusivos/montana/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/montana/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/montana/2.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/montana/3.jpg")
        ]
    },{
        nombre: 'Tela Resistente',
        colores: ['Marfil', 'Piedra','Cemniza' ],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/tejidosExclusivos/resistente/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/resistente/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/resistente/2.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/resistente/3.jpg")
        ]
    },{
        nombre: 'Tela Simetry',
        colores: ['Cafe', 'Beiige' ],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/tejidosExclusivos/simetry/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/simetry/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/simetry/2.jpg"),
        ]
    },{
        nombre: 'Tela Tahiti',
        colores: ['Grey', 'Beige','Ivory' ],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/tejidosExclusivos/tahiti/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/tahiti/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/tahiti/2.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/tahiti/3.jpg")
        ]
    },{
        nombre: 'Tela Yute',
        colores: ['White', 'Brown' ],
        categoria: 'Telas Exclusivas',
        ancho: '2.80',
        images: [
            require("../../assets/img/productos/tejidosExclusivos/yute/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/yute/1.jpg"),
            require("../../assets/img/productos/tejidosExclusivos/yute/2.jpg"),
        ]
    },
].map(producto => ({
    ...producto,
    id: generateIdFromName(producto.nombre),
    slug: `${producto.nombre.toLowerCase().replace(/\s+/g, '-')}-${producto.categoria.toLowerCase().replace(/\s+/g, '-')}`
}));

export default productosTejidosExclusivos ;